import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { User } from 'Types/User'
import {
  UserManagementTableHeader,
  UserManagementTableStyled,
  HeaderPart,
  UserManagementTableContent,
} from './UserManagementTable.styled'
import { UserManagementRow } from 'Features/accountSettings/components/UserManagement/UserManagmentRow/UserManagementRow'
import { nanoid } from 'nanoid'

type UserManagementTableProps = {
  users: Array<User>
}

export const UserManagementTable = ({ users }: UserManagementTableProps) => {
  const { t } = useTranslation('accountSettings')
  const [extraOptionsModalEmail, setModalExtraOptionsId] = useState<string>('')

  const renderUsers = () => {
    if (users) {
      return users.map((user) => (
        <UserManagementRow
          key={nanoid()}
          user={user}
          shouldShowExtraOptionsModal={user.email === extraOptionsModalEmail}
          setExtraModalOn={(close) => {
            setModalExtraOptionsId(close == '' ? '' : user.email)
          }}
        />
      ))
    }
  }

  return (
    <UserManagementTableStyled>
      <UserManagementTableHeader>
        <HeaderPart css={{ width: '20%' }}>{t('user_management.name')}</HeaderPart>
        <HeaderPart css={{ width: '25%' }}>{t('user_management.email')}</HeaderPart>
        <HeaderPart css={{ width: '20%' }}>{t('user_management.permissions')}</HeaderPart>
        <HeaderPart css={{ width: '35%' }}>{t('user_management.domains')}</HeaderPart>
      </UserManagementTableHeader>
      <UserManagementTableContent>{renderUsers()}</UserManagementTableContent>
    </UserManagementTableStyled>
  )
}
